import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useEntityCountSuspense } from "api/generated/entities/entities";

export function useEntityCountQuery(entityId: number) {
    return useEntityCountSuspense(entityId, {
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
